import { Dispatch, createContext, useReducer } from "react";
import { deviceReducer, DeviceReducerAction } from "../reducers/deviceReducer";
import { Device } from "../utils/response";

export interface DeviceContent extends Device {
  isActive?: boolean;
}

interface DeviceContextInterface {
  device: DeviceContent[];
  deviceDispatch: Dispatch<DeviceReducerAction>;
}

export const DeviceContext = createContext<DeviceContextInterface>({device: [], deviceDispatch: () => {}});

const DeviceContextProvider = ({ children }: {children: JSX.Element}) => {
  const [device, deviceDispatch] = useReducer(deviceReducer, []);

  return (
    <DeviceContext.Provider value={ {device, deviceDispatch} }>
      { children }
    </DeviceContext.Provider>
  );
};

export default DeviceContextProvider;
